import React, { useCallback, useEffect, useState } from 'react';
import { AssigneeModel } from '@/typings/models/Assignee';
import { LeadTaskModel } from '@/typings/models/LeadTask';
import { fetchLeadTasksList } from '@/services/api/leadTask';
import { TasksList } from '@/pages/Tasks/TasksList';
import { processAPIResponseNow } from '@/utils/request';

interface AgentTasksTabProps {
  agent: AssigneeModel;
}

const AgentTasksTab: React.FC<AgentTasksTabProps> = ({ agent }) => {
  const [tasks, setTasks] = useState<LeadTaskModel[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchTasks = useCallback(() => {
    if (!agent?.id) return;

    setLoading(true);
    fetchLeadTasksList({
      query: {
        assignee_id: agent.id,
        page_size: 50,
      },
    }).then(Response => {
      processAPIResponseNow(Response, {
        onSuccess(data) {
          setTasks(data);
        },
        onEnd() {
          setLoading(false);
        },
      }, 'data');
    });
  }, [agent?.id]);

  useEffect(() => {
    fetchTasks();
  }, [fetchTasks]);

  return (
    <TasksList
      data={tasks}
      request={fetchTasks}
      loading={loading}
      hideCreate
      showAssignee={false}
      showLead={true}
      showDescription={true}
    />
  );
};

export default AgentTasksTab;
